import { Subject } from 'rxjs';

export const goHome = new Subject<boolean>();

export const emitGoToHome = (): void => {
  goHome.next(true);
};
